import {FileType} from "../../../../declarations";

const UserDocumentationsFileTypes: FileType[] = [
  "cease_and_desist_notice",
  "bankruptcy",
  "account_statement",
  "contract",
  "borrower_membership_agreement",
  "transaction_history",
  "redacted_assignment",
  "terms_and_conditions",
  "consent_form",
  "representation_notice",
  "bank_statement",
  "general",
];
export {UserDocumentationsFileTypes};
